import useMediaQuery from "./useMediaQuery";

export const REDUCED_MOTION_QUERY: string = "(prefers-reduced-motion: reduce)";

/**
 * Whether the user asked the OS for reduced motion, re-rendering when that setting flips.
 *
 * CSS already honours the setting through the --motion-* multipliers in styles/base/motion.scss;
 * this is for motion decided in JS — skip a measured slide, snap an indicator, keep a timer still.
 * Reduced motion keeps meaning (opacity, colour) and drops movement; it never removes feedback.
 */
const usePrefersReducedMotion = (): boolean => useMediaQuery(REDUCED_MOTION_QUERY);

export default usePrefersReducedMotion;
